import AddStore from './AddStore'
import {connect} from 'react-redux';
import * as action from '../../state/detail/action'
import * as selector from '../../state/detail/selector'

const mapStateToProps = (state) => {
    return {
        title:'Add Clinic',
        store: selector.selectStore(state),
        validationMessageList: selector.selectValidationMessageList(state),
        redirect:selector.selectRedirect(state),
        isFetching: selector.selectIsFetching(state)
    }
}

const mapDispatchToProps = {
    editStore: action.editFormValue,
    saveStore: action.createOrUpdateStore,
    pushValidationList: action.pushValidationList,
    clearState:action.clearState,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddStore)



// WEBPACK FOOTER //
// ./src/modules/store/component/add/AddStoreContainer.js